import React, { useState, FC, useEffect } from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import AccountCircle from "@mui/icons-material/AccountCircle";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, useTheme } from "@mui/material";
import { useRecoilState } from "recoil";
import { userState } from "../../../../states/userState";
import { setUserToLocalStorage } from "../../../../utils/functions/localStorageManager";
import { User } from "../../../../types";
import { productNoFocusState } from "../../../../states/variableState";

type Props = {
  fullWidth: boolean;
  label: string;
  multiline: boolean;
  required: boolean;
  rows: number;
  type: string;
  InputProps?: TextFieldProps["InputProps"];
  placeholder: string;
  disabled: boolean;
  productNo: string;
  setProductNo: React.Dispatch<React.SetStateAction<string>>;
  productBno: string;
  setProductBno: React.Dispatch<React.SetStateAction<string>>;
  colorMode: string;
  setMode: string;
  setToggleBnoClear: React.Dispatch<React.SetStateAction<boolean>>;
};
const TextInputForProductNo: FC<Props> = (props) => {
  const {
    productNo,
    setProductNo,
    productBno,
    setProductBno,
    colorMode,
    setToggleBnoClear,
    setMode,
  } = props;
  const [user, setUser] = useRecoilState(userState);
  // const [productNo, setProductNo] = useState(user.initialParameters.productNo);
  const theme = useTheme();
  const [productFocusState, setProductFocusState] =
    useRecoilState(productNoFocusState);
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const regex = /^\d{0,8}$/; // 最大8桁の数字のみを許可する正規表現

    if (regex.test(value)) {
      setToggleBnoClear(true);
      setProductNo(value);
    }
  };
  const handleOnFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setProductFocusState(true);
    setProductNo("");
    setProductBno("");
    setUser((prevUser: User) => {
      // const newUser: User = { ...prevUser, isAuth: true };
      // デフォルト値を設定
      // const defaultInitialParams: InitialParameters = {
      //   workersForInput: [],
      //   workersForList: [],
      //   factoryNo: [],
      //   productNo: "",
      //   productBno: "",
      //   latestUrl: "",
      // };
      let newUser: User;
      if (setMode === "view") {
        newUser = {
          ...prevUser,
          isAuth: true,
          initialParameters: {
            // ...defaultInitialParams,
            ...prevUser.initialParameters,
            productNo: "",
            productBno: "",
          },
        };
      } else if (setMode === "matrix") {
        newUser = {
          ...prevUser,
          isAuth: true,
          initialParameters: {
            // ...defaultInitialParams,
            ...prevUser.initialParameters,
            productNoForMatrix: "",
            productBnoForMatrix: "",
          },
        };
      } else {
        if (setMode === "inputSingle") {
          newUser = {
            ...prevUser,
            isAuth: true,
            initialParameters: {
              // ...defaultInitialParams,
              ...prevUser.initialParameters,
              productNoForSingleInput: "",
              productBnoForSingleInput: "",
            },
          };
        } else {
          newUser = {
            ...prevUser,
            isAuth: true,
            initialParameters: {
              // ...defaultInitialParams,
              ...prevUser.initialParameters,
              productNoForMultiInput: "",
              productBnoForMultiInput: "",
            },
          };
        }
      }

      //LocalStorageにユーザ情報をセット
      setUserToLocalStorage(newUser);
      return newUser;
    });
  };
  const handleOnBlur = (e: React.FocusEvent<HTMLElement>) => {
    setProductFocusState(false);
    let setString =
      String(productNo).length > 0 ? String(productNo).padStart(8, "0") : "";
    setProductNo(setString);
    let newUser: User;
    setUser((prevUser: User) => {
      if (setMode === "view") {
        newUser = {
          ...prevUser,
          isAuth: true,
          initialParameters: {
            // ...defaultInitialParams,
            ...prevUser.initialParameters,
            productNo: setString,
          },
        };
      } else if (setMode === "matrix") {
        newUser = {
          ...prevUser,
          isAuth: true,
          initialParameters: {
            // ...defaultInitialParams,
            ...prevUser.initialParameters,
            productNoForMatrix: setString,
          },
        };
      } else {
        if (setMode === "inputSingle") {
          newUser = {
            ...prevUser,
            isAuth: true,
            initialParameters: {
              // ...defaultInitialParams,
              ...prevUser.initialParameters,
              productNoForSingleInput: setString,
            },
          };
        } else {
          newUser = {
            ...prevUser,
            isAuth: true,
            initialParameters: {
              // ...defaultInitialParams,
              ...prevUser.initialParameters,
              productNoForMultiInput: setString,
            },
          };
        }
      }
      //LocalStorageにユーザ情報をセット
      setUserToLocalStorage(newUser);
      return newUser;
    });
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {};
  // useEffect(() => {
  //   setProductNo(user.initialParameters.productNo);
  // }, [user.initialParameters.productNo]);
  return (
    <TextField
      // color={"#0adcc0"}
      variant="standard"
      fullWidth={props.fullWidth}
      label={props.label}
      InputLabelProps={{ shrink: true }}
      margin="dense"
      multiline={props.multiline}
      required={props.required}
      rows={props.rows}
      value={productNo}
      type={props.type}
      onChange={handleOnChange}
      onFocus={handleOnFocus}
      onBlur={handleOnBlur}
      onKeyDown={handleKeyDown}
      disabled={props.disabled}
      placeholder={props.placeholder}
      InputProps={{
        ...props.InputProps,
        endAdornment: props.InputProps ? (
          // <InputAdornment position="start">
          //   <div
          //     style={{
          //       backgroundColor: "#0adcc0",
          //       width: "36px",
          //       height: "20px",
          //       paddingLeft: "6px",
          //       borderRadius: "5px",
          //       cursor: "pointer",
          //     }}
          //     onClick={props.onClick}
          //   >
          //     <SearchIcon />
          //   </div>
          // </InputAdornment>
          <></>
        ) : null,
        sx: {
          "& .MuiInput-underline:before": {
            borderBottomColor:
              colorMode === "light"
                ? theme.palette.foreColor.main
                : theme.palette.foreColor.light, // 通常時の下線の色
          },
          "& .MuiInput-underline:after": {
            borderBottomColor:
              colorMode === "light"
                ? theme.palette.foreColor.main
                : theme.palette.foreColor.light, // フォーカス時の下線の色
          },
          "& .MuiInput-underline:hover:before": {
            borderBottomColor: `${
              colorMode === "light"
                ? theme.palette.foreColor.main
                : theme.palette.foreColor.light
            }!important`, // ホバー時の下線の色
          },
          "& .MuiInput-underline": {
            borderBottomColor: `${
              colorMode === "light"
                ? theme.palette.foreColor.main
                : theme.palette.foreColor.light
            }!important`, // ホバー時の下線の色
          },
          // 他のスタイルもここに追加できます
        },
      }}
      sx={{
        margin: "0 0",

        "&&&": {
          // color: "blue",
          width: "78px",
          height: "28px",
          backgroundColor:
            colorMode === "light"
              ? theme.palette.backColor.main
              : theme.palette.backColor.dark,
          // padding: "5px 10px 2px 10px",
          borderRadius: "5px",
        },
        "& label": {
          padding: "10px",
          color:
            colorMode === "light"
              ? theme.palette.foreColor.main
              : theme.palette.foreColor.light,
          fontSize: "18px",
        },
        "& svg": {
          // marginTop: "5px",
          color: "#f0f2f5",
        },
        "& input": {
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: "2px",
          paddingLeft: "0px",
          fontSize: "16px",
          color:
            colorMode === "light"
              ? theme.palette.foreColor.main
              : theme.palette.foreColor.light,
          fontWeight: "700",
          "&:hover": {
            color:
              colorMode === "light"
                ? theme.palette.foreColor.main
                : theme.palette.foreColor.light,
          },
          "&:focus": {
            color:
              colorMode === "light"
                ? theme.palette.foreColor.main
                : theme.palette.foreColor.light,
          },
          //   backgroundColor: "black",
        },
        "& .MuiSvgIcon-root": {
          color: "#f0f2f5",
        },
        "& .MuiInputBase-input": {
          fontSize: "16px",
          color:
            colorMode === "light"
              ? theme.palette.foreColor.main
              : theme.palette.foreColor.light,
          fontWeight: "700",
        },
        // InputPropsで指定したスタイル以外にもここで追加できます
      }}
    />
  );
};
export default TextInputForProductNo;
